import MyAvatar from "./my-avatar"
import NewUserPage from "./new-user-page"

const CurrentUser = { MyAvatar, NewUserPage }

export default CurrentUser
